import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { createPolicyMenu } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function createPolicyMenuList({
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(createPolicyMenu(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: {
    AccountId: number;
    ProcedureId: number;
    ProcedureName: string;
  };
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
};

type TSnapshot = unknown;

function useCreatePolicyMenu(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ accountId }: TVariables) => {
    const accountProcedure = await createPolicyMenuList({ accountId });
    if (accountProcedure.Data) {
      queryClient.invalidateQueries([
        'get_procedure_builder_procedures',
        accountId,
      ]);
      queryClient.invalidateQueries(['get_procedure'], {
        refetchInactive: true,
      });
    } else if (accountProcedure.Errors) throw accountProcedure;
    return accountProcedure;
  });
}

export { useCreatePolicyMenu };
